<template>
  <div>
    <div class="inner">
      <h2 class="Head Head--cl01 Head--sp-cl01 Head--mg_md">
        <span
          class="Head__main Head--md"
        >Today’s class</span><br><span class="Head__main_jp">今日のクラス</span>
      </h2>
    </div>
    <div class="Card__inner inner ft_en">
      <div class="Card__area Card__schedule_area">
        <div
          v-if="featuredItem"
          :class="`Card__box_list_main Card__box--${classStatus}`"
          @click="handleFirstClass(featuredItem.id)"
        >
          <div class="Card__box_time">
            {{ featuredItem.learning_time }}
          </div>
          <div class="Label__op Card__box_op_label">
            開催中
          </div>
          <div
            class="Card__box Card__box--lg Card__box_first"
            :style="parseCssVars(featuredItem.master_program_category)"
          >
            <div class="Label Label__time Card__box_time_label">
              {{ featuredItem.time }} min
            </div>
            <div class="Card__box_label">
              <span
                class="Card__box_label_class"
              >{{ featuredItem.class }}</span><span
                class="Card__box_label_name"
              >{{ featuredItem.master_instructor.name }}</span>
            </div>
          </div>
        </div>
        <div
          v-for="(item,key) of listScheduleToDay"
          :key="key"
          :class="`Card__box_list ${item.is_new_date ? 'Card__date' : ''}`"
          @click="openModalSchedule(item.id)"
        >
          <div class="Card__date_area">
            <div class="Card__date_box">
              <span class="Card__date_box_tx">{{ handleDateToDay(item.date) }}</span>
              <span class="Card__day_tx_sub">&#040;{{ handleShowDate(item.date) }}&#041;</span>
            </div>
          </div>
          <div class="Card__box_top">
            <div class="Card__box_time">
              {{ item.learning_time }}
            </div>
            <div class="Label Label__time Card__box_time_label_secondary">
              {{ item.time }} min
            </div>
          </div>
          <div
            class="Card__box Card__box--sm"
            data-modal-open="modal-1"
            :style="parseCssVars(item.master_program_category)"
          >
            <div class="Card__box_label Card__box_label_secondary">
              <span class="Card__box_label_class">{{ item.class }}</span><span
                class="Card__box_label_name"
              >{{ item.master_instructor.name }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <p class="Scroll_tx Schedule__scroll_tx">
      タップして横に動かせます
    </p>
  </div>
</template>
<script>
import ScheduleToDay from '@/services/scheduleService'
import moment from 'moment'
import { parseCssVars } from '@/helpers/programCategory'

export default {
  data() {
    return {
      listScheduleToDay: [],
      featuredItem: null,
      timestamp: '',
      nextDay: 0,
      classStatus: 'not_open',
      oneMinutesMillisecond: 60 * 1000,
      fiveMinutesMillisecond: 5 * 60 * 1000,
      tenMinutesMillisecond: 10 * 60 * 1000,
      oneMonthMillisecond: 30 * 24 * 60 * 60 * 1000
    }
  },
  mounted() {
    this.getListScheduleToDay()
  },
  methods: {
    handleDateToDay(date) {
      return moment(date).format('M.D')
    },
    handleShowDate(date) {
      return moment(date).format('ddd')
    },
    openModalSchedule(scheduleId, isOngoingClass) {
      this.$store.dispatch('modal/openModalSchedule', { scheduleId, isOngoingClass })
    },
    async getListScheduleToDay() {
      const response = await ScheduleToDay.classToday()
      if (response.data.length !== 0) {
        response.data.forEach(element => {
          element.date = moment(element.date).local()
          element.learning_time = element.date.format('HH:mm')
        })
        this.getClassFromNow(response.data)
      }
    },
    getClassFromNow(schedules) {
      const today = moment()._d
      const miniSeconds = Date.parse(today)
      const result = []
      schedules.forEach(element => {
        const format_time_ios = moment(element.date).format('YYYY/MM/DD HH:mm:ss')
        if (Date.parse(format_time_ios) + element.time * this.oneMinutesMillisecond + this.fiveMinutesMillisecond >= miniSeconds) {
          result.push(element)
        }
      })
      if (result.length !== 0) {
        this.sortSchedule(result)
      }
    },
    sortSchedule(schedules) {
      const now = moment()._d
      if (schedules[1]) {
        const format_time_ios_first = moment(schedules[0].date).format('YYYY/MM/DD HH:mm:ss')
        const format_time_ios_second = moment(schedules[1].date).format('YYYY/MM/DD HH:mm:ss')
        if (Date.parse(now) >= Date.parse(format_time_ios_second) - this.tenMinutesMillisecond &&
          Date.parse(now) >= Date.parse(format_time_ios_first) + schedules[0].time * this.oneMinutesMillisecond
        ) {
          this.listScheduleToDay = schedules.slice(1, 10)
        } else {
          this.listScheduleToDay = schedules.slice(0, 9)
        }
      } else {
        this.listScheduleToDay = schedules.slice(0, 9)
      }
      this.featuredItem = this.listScheduleToDay.shift()
      this.checkClassOpen(this.featuredItem)
      this.handleNextDay(this.listScheduleToDay)
    },
    handleNextDay(schedules) {
      const featuredItemDay = this.featuredItem.date
      const listDate = []
      let currentListDate = null
      schedules.forEach(function(item, key) {
        let isNewDate = false
        if (item.date !== null) {
          if (!currentListDate || currentListDate !== moment(item.date).format('YYYY/MM/DD')) {
            currentListDate = moment(item.date).format('YYYY/MM/DD')
            if (currentListDate === moment(featuredItemDay).format('YYYY/MM/DD')) {
              isNewDate = false
            } else {
              isNewDate = true
            }
          }
          const itemClass = item
          itemClass.is_new_date = isNewDate
          listDate.push(itemClass)
        }
      })
      this.listScheduleToDay = listDate
    },
    checkClassOpen(data) {
      const now = moment()._d
      const format_time_ios = moment(data.date).format('YYYY/MM/DD HH:mm:ss')
      if (Date.parse(now) >= Date.parse(format_time_ios) - this.tenMinutesMillisecond && Date.parse(now) <= Date.parse(format_time_ios) + data.time * this.oneMinutesMillisecond + this.fiveMinutesMillisecond) {
        this.classStatus = 'open'
      } else {
        this.classStatus = 'not_open'
      }
    },
    handleFirstClass(scheduleId) {
      this.openModalSchedule(scheduleId, this.classStatus === 'open')
    },
    parseCssVars: parseCssVars
  }
}
</script>
